// extracted by mini-css-extract-plugin
export var circle = "_gx-1";
export var exitConfirmationModal = "_gx-5";
export var iframe = "_gx-0";
export var offline = "_gx-3";
export var online = "_gx-2";
export var workstationSelectError = "_gx-4";